import api from "api";


const tickets = {
    get: () => {
        return api().get('/users/wallet')
    },

    checkIn: (payload) => {
        return api().post('/checkin', payload)
    },

    create: (payload) => {
        return api().post('/products', payload)
    },

    update: (id, payload) => {
        return api().post(`/products/${id}`, payload)
    },

    delete: (id) => {
        return api().delete(`/products/${id}`)
    },

    createBulk: (payload) => {
        return api().post('/products/bulk', payload)
    },

    updateBulk: (payload) => {
        return api().put('/products/bulk', payload)
    },

    deleteBulk: (payload) => {
        return api().delete('/products/delete/bulk', payload)
    },

    getTicketForEvent: (slug) => {
        return api().get(`/events/detail/${slug}/tickets`)
    },

    removeDraft: (slug) => {
        return api().post(`/events/${slug}/finish`)
    },

    getAllItems: (slug, query) => {
        const {
            type,
            deleted // include, exclude, only
        } = query;

        const validType = type === 'both' ? null : type;

        return api().get(`/events/${slug}/items`, {
            params: {
                type: validType,
                deleted
            }
        })
    }
}

export default tickets;